<template>
  <div class="list">
    <div  v-for="(item, index) in echoArr" :key="index" class="item">
      <p @click="goInfo(item.id)" class="title ellipsis">{{item.title}}</p>
      <div class="flex_r fgray margint12">
        <img class="ava" :src="item.logo" alt="" />
        <div class="name">{{item.author}}</div>
        <div class="time">{{item.time}}</div>
        <svgIcon v-if="showDel" class="f16 marginl20"  name='delete'  />
        <span v-if="showDel" @click="del(item.id)" class="fgray marginl4 cursor f16">删除</span>
      </div>
      <div v-html="item.content" class="content limit2 margint12 f18 line28"></div>

      <div class="msg margint24 flex_r">
        <div class="view flex_r">
          <svgIcon name="eye" />
          <span class="marginl12">{{item.hits}}</span>
        </div>
        <div class="message flex_r">
          <svgIcon name="msg" />
          <span class="marginl12">{{item.comments}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "echoGroup",
  props: {
    showDel: {
      type: Boolean,
      default: false
    },
    echoArr: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    goInfo(id) {
      if(!this.$isLogin())return
      this.$router.push({
        name: "echoInfo",
        params: {
          id,
        }
      });
    },
    async del(id){
      this.$alert('确定删除吗？',{
        showClose: true,
        showCancelButton: true,
        callback: async(action,instance)=>{
          if(action=='confirm'){
            let { data, msg } = await this.$http.get(this.$api.delTz,{params: { id } })
            this.$message.success(msg);
            this.$emit('del',index)
          }
        }
      })
    }
  },
};
</script>
<style lang="less" scoped>
.list {
    width: 1184px;
    .item {
      padding: 40px 0 20px;
      box-sizing: border-box;
      border-bottom: 2px solid #fafafa;
      .title {
        font: 600 20px normal;
        line-height: 28px;
        color: #ad2729;
        cursor: pointer;
        &:hover{
          text-decoration: underline;
        }
      }
      .ava {
        width: 20px;
        height: 20px;
        border-radius: 50%;
      }
      .name {
        margin-left: 6px;
      }
      .time {
        margin-left: 16px;
      }
      .content {
        word-break: break-all;
        word-wrap: break-word;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        overflow: hidden;
        /deep/ img{
          width: 200px;
          height: 200px;
        } 
      }
      .message {
        margin-left: 28px;
      }
    }
  }
</style>